__turbopack_context__.v({
  "disabled": "MenuItemCard-module__I4sMoG__disabled",
  "image": "MenuItemCard-module__I4sMoG__image",
  "menuItemCard": "MenuItemCard-module__I4sMoG__menuItemCard",
  "menuItemCardBody": "MenuItemCard-module__I4sMoG__menuItemCardBody",
});
